import React from 'react';
import { render } from 'react-dom';

import select from '../utils/select';
import { SELECTOR } from './constants';
import CopyLink from './CopyLink';

import { IGaLabel } from '../types';

interface IBuildCopyLinkParams {
  ariaLabel: string;
  ga: IGaLabel;
  isMinimal: boolean;
  selectorSuffix: string;
  urlPath: string;
}

export default function buildCopyLink({
  ariaLabel,
  ga,
  isMinimal,
  selectorSuffix,
  urlPath,
}: IBuildCopyLinkParams): void {
  render(
    <CopyLink
      ariaLabel={ariaLabel}
      display={{ isMinimal }}
      ga={ga}
      urlPath={urlPath}
    />,
    select(`#${SELECTOR}-${selectorSuffix}`)
  );
}
